import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { required, composeValidators } from '../../../util/validators';
import {
    FieldCurrencyInput,
    FieldSelect,
    FieldCheckbox,
    FieldTextInput,
} from '../../../components';
import css from './PackageComponent.css';
import classNames from 'classnames';
import {
    RIDINGS_PER_WEEK_FULL,
    RIDINGS_PER_WEEK_ENOUGHT,
    RIDINGS_PER_WEEK_MODERATE,
} from '../../../marketplace-custom-config';

const AllowedPackagesNumber = 3;

const PackageComponent = ({ defaultProps, packageNumber }) => {
    const { config, values, isFlexible, intl, form } = defaultProps;
    const { package1, package2, package3, availability } = values;
    const currentPackage = values[`package${packageNumber}`] || {};

    const isMainPackage = packageNumber == 1;
    const isActive = isMainPackage || currentPackage.active;

    if (!isFlexible && !isMainPackage) return null;

    const isAvailabilityOptionDisabled = option => {
        const selectedAvailabilities = [
            package1.active ? package1.availability : null,
            package2.active && typeof package2.price === 'number' ? package2.availability : null,
            package3.active && typeof package3.price === 'number' ? package3.availability : null,
        ].filter(a => a !== currentPackage.availability);

        return selectedAvailabilities.includes(option) || option === availability;
    };

    const options = [RIDINGS_PER_WEEK_MODERATE, RIDINGS_PER_WEEK_ENOUGHT, RIDINGS_PER_WEEK_FULL];

    const noGreaterOrLessThan = (message, min, max) => (value = {}) =>
        Number(value.amount / 100) <= max && Number(value.amount / 100) >= min
            ? undefined
            : message;

    const noGreaterOrLessThanValidator = (min, max) =>
        noGreaterOrLessThan(`Darf nicht größer als ${max} und kleiner als ${min} sein.`, min, max);

    return (
        <div
            className={classNames(css.packageWrapper, {
                [css.nonActivePackage]: !isActive,
                [css.flexiblePackageWrapper]: isFlexible,
            })}
        >
            <div className={css.packageWrapperTitle}>
                <FormattedMessage
                    id={`EditListingPricingForm.packageWrapperTitle${
                        isMainPackage ? 'Basic' : 'Num'
                    }`}
                    values={{ num: packageNumber }}
                />

                {isMainPackage ? null : (
                    <FieldCheckbox
                        type="checkbox"
                        id={`package${packageNumber}.active`}
                        name={`package${packageNumber}.active`}
                        className={css.noPaddingCheckbox}
                        togglerMode
                        reversePosition
                    />
                )}
            </div>

            {isActive ? (
                <div className={css.packageContent}>
                    <FieldSelect
                        type="text"
                        id={`package${packageNumber}.availability`}
                        name={`package${packageNumber}.availability`}
                        validate={required('Dieses Feld wird benötigt')}
                        form={form}
                        disabled={!isFlexible}
                        placeholder="Verfügbarkeit"
                        optionsList={options.map(optionName => ({
                            label: intl.formatMessage({
                                id: `EditListingDescriptionForm.desiredAvailabilityRadioButton-${optionName}`,
                            }),
                            value: optionName,
                            disabled: isAvailabilityOptionDisabled(optionName),
                        }))}
                    />

                    <div className={css.oneRowWrapper}>
                        <FieldCurrencyInput
                            id={`package${packageNumber}.price`}
                            name={`package${packageNumber}.price`}
                            className={css.packagePrice}
                            placeholder="Preis pro Monat"
                            currencyConfig={
                                values.currency
                                    ? { ...config.currencyConfig, currency: values.currency }
                                    : config.currencyConfig
                            }
                            validate={composeValidators(
                                required('Dieses Feld wird benötigt'),
                                noGreaterOrLessThanValidator(0, 9999)
                            )}
                        />

                        <FieldSelect
                            type="text"
                            id={`package${packageNumber}.currency`}
                            name={`package${packageNumber}.currency`}
                            className={css.packageCurreny}
                            disabled
                            form={form}
                            placeholder="Währung"
                            optionsList={[values.currency || config.currencyConfig].map(c => ({
                                label: c,
                                value: c,
                            }))}
                        />
                    </div>

                    {isFlexible ? (
                        <FieldTextInput
                            id={`package${packageNumber}.desc`}
                            name={`package${packageNumber}.desc`}
                            maxLength={500}
                            type="textarea"
                            className={css.packageDesc}
                            placeholder={intl.formatMessage({
                                id: 'EditListingPricingForm.packageDescLabel',
                            })}
                        />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export const PackageComponents = props =>
    Array.from({ length: AllowedPackagesNumber }, (_, i) => (
        <PackageComponent key={i} defaultProps={props} packageNumber={i + 1} />
    ));
